import {useState} from "react"

export function useFetch (type =null) {

	const [loading, setLoading] = useState(true)
	const [data, setData] = useState(type)
	const [errors, setErrors] = useState(null)

	const fetchApi = (url='api', options) => {
		fetch("https://maths-au-quotidien.fr/react-automaths/"+url+".php", {
		      method: 'POST',
		      body: JSON.stringify(options)
		    })
		    .then(response => response.json())
		    .then(datas => {
		    	setData(datas)
		    })
		    .catch(err => {
		    	setErrors('err')
		    })
		    .finally(setLoading(false))		
	}

	return {
		loading, data, errors, fetchApi, setData
	}
}